var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.97 21.5002H16.96H7.05C4.27 21.5002 2 19.2502 2 16.4602V16.4502C2 16.4502 2.006 12.0242 2.014 9.79818C2.015 9.38018 2.495 9.14618 2.822 9.40618C5.198 11.2912 9.447 14.7282 9.5 14.7732C10.21 15.3422 11.11 15.6632 12.03 15.6632C12.95 15.6632 13.85 15.3422 14.56 14.7622C14.613 14.7272 18.767 11.3932 21.179 9.47718C21.507 9.21618 21.989 9.45018 21.99 9.86718C22 12.0762 22 16.4402 22 16.4402C22 19.2302 19.76 21.4902 16.97 21.5002Z",
    fill: "#8A92A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0309 3.49957H7.05086C5.17486 3.49957 3.47086 4.54157 2.60486 6.17357C2.41086 6.53857 2.50286 6.99357 2.82586 7.25157L10.2509 13.1906C10.7709 13.6106 11.4009 13.8196 12.0309 13.8196C12.0349 13.8196 12.0379 13.8196 12.0409 13.8196C12.0439 13.8196 12.0479 13.8196 12.0509 13.8196C12.6809 13.8196 13.3109 13.6106 13.8309 13.1906L21.2559 7.25157C21.5789 6.99357 21.6709 6.53857 21.4769 6.17357C20.6109 4.54157 18.9069 3.49957 17.0309 3.49957Z",
    fill: "#00365A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.33fbf1e400b19e282b5c5753fc2d7946.svg";
export { ForwardRef as ReactComponent };